import { render, staticRenderFns } from "./sound-index.vue?vue&type=template&id=825c58bc&scoped=true&"
import script from "./sound-index.vue?vue&type=script&lang=js&"
export * from "./sound-index.vue?vue&type=script&lang=js&"
import style0 from "./sound-index.vue?vue&type=style&index=0&id=825c58bc&prod&lang=css&"
import style1 from "./sound-index.vue?vue&type=style&index=1&id=825c58bc&prod&scoped=true&lang=css&"
import style2 from "./sound-index.vue?vue&type=style&index=2&id=825c58bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825c58bc",
  null
  
)

export default component.exports